import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { prepareFormData, useFormHandler } from '../../components/Custom_Hooks/useFormHandler';
import { companyUserCreate, companyUserUpdate, contraLedgerListing, groupList, companyUserList } from '../../redux/actions/action-creator';
import Form from '../../components/Form/Form';
import MasterCreationFooter from '../../components/Footer/Master_Footer/MasterCreationFooter';
import { toast } from 'react-toastify';
import { getVoucherDate } from '../../components/Date_Formate_Utilitiy/Index';
import DropdownLayout_1 from '../../components/Dropdown/DropdownLayout_1';
import { openModal, closeModal } from '../../redux/actions/action-creator';

const defaultPermissionsList = [
    // MASTERS
    { id: 1, category: 'MASTERS', name: 'Groups', type: 'Accounting Masters', create: true, alter: true, view: true, delete: true, print: false, export: false, email: false, whatsapp: false },
    { id: 2, category: 'MASTERS', name: 'Ledgers', type: 'Accounting Masters', create: true, alter: true, view: true, delete: false, print: true, export: false, email: false, whatsapp: false },
    { id: 3, category: 'MASTERS', name: 'Voucher Types', type: 'Accounting Masters', create: true, alter: false, view: true, delete: false, print: true, export: true, email: false, whatsapp: false },
    { id: 4, category: 'MASTERS', name: 'Stock Groups', type: 'Inventory Masters', create: false, alter: false, view: true, delete: false, print: true, export: true, email: true, whatsapp: false },
    { id: 5, category: 'MASTERS', name: 'Stock Items', type: 'Inventory Masters', create: true, alter: false, view: false, delete: false, print: true, export: true, email: true, whatsapp: true },
    { id: 6, category: 'MASTERS', name: 'Stock Categories', type: 'Inventory Masters', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 7, category: 'MASTERS', name: 'Stock Company', type: 'Inventory Masters', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 8, category: 'MASTERS', name: 'Units', type: 'Inventory Masters', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 9, category: 'MASTERS', name: 'Godowns', type: 'Inventory Masters', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    // VOUCHER TYPES
    { id: 10, category: 'VOUCHER TYPES', name: 'Contra', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: false, export: false, email: false, whatsapp: false },
    { id: 11, category: 'VOUCHER TYPES', name: 'Credit Note', type: 'Transactions', create: true, alter: true, view: true, delete: false, print: true, export: false, email: false, whatsapp: false },
    { id: 12, category: 'VOUCHER TYPES', name: 'Debit Note', type: 'Transactions', create: true, alter: false, view: true, delete: false, print: true, export: true, email: false, whatsapp: false },
    { id: 13, category: 'VOUCHER TYPES', name: 'Delivery Note', type: 'Transactions', create: false, alter: false, view: true, delete: false, print: true, export: true, email: true, whatsapp: false },
    { id: 14, category: 'VOUCHER TYPES', name: 'Journal', type: 'Transactions', create: true, alter: false, view: false, delete: false, print: true, export: true, email: true, whatsapp: true },
    { id: 15, category: 'VOUCHER TYPES', name: 'Payment', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 16, category: 'VOUCHER TYPES', name: 'Physical Stock', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 17, category: 'VOUCHER TYPES', name: 'Purchase', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 18, category: 'VOUCHER TYPES', name: 'Purchase Order', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 19, category: 'VOUCHER TYPES', name: 'Receipt', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 20, category: 'VOUCHER TYPES', name: 'Receipt Note', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 21, category: 'VOUCHER TYPES', name: 'Sales', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 22, category: 'VOUCHER TYPES', name: 'Sales Order', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    { id: 23, category: 'VOUCHER TYPES', name: 'Stock Transfer', type: 'Transactions', create: true, alter: true, view: true, delete: true, print: true, export: true, email: true, whatsapp: true },
    // REPORTS
    { id: 24, category: 'REPORTS', name: 'DayBook', type: 'Reports', create: false, alter: false, view: true, delete: false, print: false, export: false, email: false, whatsapp: false },
    { id: 25, category: 'REPORTS', name: 'Ledger', type: 'Reports', create: false, alter: false, view: true, delete: false, print: true, export: false, email: false, whatsapp: false },
    { id: 26, category: 'REPORTS', name: 'Stock Summary', type: 'Reports', create: false, alter: false, view: true, delete: false, print: true, export: true, email: false, whatsapp: false },
    { id: 27, category: 'REPORTS', name: 'Balance Sheet', type: 'Reports', create: false, alter: false, view: false, delete: false, print: true, export: true, email: true, whatsapp: false },
    { id: 28, category: 'REPORTS', name: 'Profit & Loss', type: 'Reports', create: false, alter: false, view: false, delete: false, print: true, export: true, email: true, whatsapp: false },
    { id: 29, category: 'REPORTS', name: 'Trial Balance', type: 'Reports', create: false, alter: false, view: false, delete: false, print: true, export: true, email: true, whatsapp: false }
];

const mapRawPermissions = (rawList) => {
    if (!Array.isArray(rawList)) return defaultPermissionsList;
    return defaultPermissionsList.map(def => {
        const matched = rawList.find(r =>
            (r.name && r.name.toLowerCase().trim() === def.name.toLowerCase().trim()) ||
            (r.feature_name && r.feature_name.toLowerCase().trim() === def.name.toLowerCase().trim())
        );
        if (matched) {
            return {
                ...def,
                id: matched.id || matched.permission_id || def.id,
                create: String(matched.create ?? matched.can_create ?? '') === '1' || matched.create === true,
                alter: String(matched.alter ?? matched.can_alter ?? '') === '1' || matched.alter === true,
                view: String(matched.view ?? matched.can_view ?? '') === '1' || matched.view === true,
                delete: String(matched.delete ?? matched.can_delete ?? '') === '1' || matched.delete === true,
                print: String(matched.print ?? matched.can_print ?? '') === '1' || matched.print === true,
                export: String(matched.export ?? matched.can_export ?? '') === '1' || matched.export === true,
                email: String(matched.email ?? matched.can_email ?? '') === '1' || matched.email === true,
                whatsapp: String(matched.whatsapp ?? matched.can_whatsapp ?? '') === '1' || matched.whatsapp === true,
            };
        }
        return def;
    });
};

function UserAndPasswordCreate({ closeModal_sec, onSuccess, editData, viewOnly }) {
    const dispatch = useDispatch();
    const { userData = null } = useSelector(state => state.auth);
    const [submitConfirm, setSubmitConfirm] = useState('');
    const [ledgers, setLedgers] = useState([]);

    // Initial state for form fields
    const [formData, setFormData] = useState({
        company_id: userData?.company_id || localStorage.getItem("company_id") || '',
        ledgerName: editData ? editData.account_no : '',
        username: editData ? editData.username : '',
        password: '',
        confirmPassword: '',
        email: editData ? (editData.email || '') : '',
        designation: editData ? editData.designation : 'Owner',
        userStatus: editData ? editData.status : 'Active',
        allowedBackDated: editData ? (editData.allowedBackDated || 'Yes') : 'Yes',
        cutOffDate: editData ? ((editData.allowedBackDated === 'No') ? '' : (editData.cutOffDate || '23-Dec-2025 (Tuesday)')) : '23-Dec-2025 (Tuesday)',
    });

    // Ledger searchable dropdown — display text state, modal open/close via redux like vouchers
    const [ledgerSearch, setLedgerSearch] = useState('');
    const [showLedgerDropdown, setShowLedgerDropdown] = useState(false);
    const [showDesignationDropdown, setShowDesignationDropdown] = useState(false);
    const [showUserStatusDropdown, setShowUserStatusDropdown] = useState(false);
    const [showAllowedBackDatedDropdown, setShowAllowedBackDatedDropdown] = useState(false);

    // Cut-off date raw input — user types here, parsed exactly like voucher date fields
    const [cutOffDateRaw, setCutOffDateRaw] = useState(
        editData ? (editData.allowedBackDated === 'No' ? '' : ((editData.cutOffDate || '23-Dec-2025 (Tuesday)').replace(/\s*\(.*\)/, '').trim())) : '23-Dec-2025'
    );

    const { company_session } = useSelector(state => state.common);

    useEffect(() => {
        const fetchLedgers = async () => {
            const companyId = userData?.company_id || localStorage.getItem("company_id");
            if (companyId) {
                const formDataObj = new FormData();
                formDataObj.append('company_id', companyId);
                try {
                    // 1. Fetch groups of the company
                    const groupsResponse = await dispatch(groupList(formDataObj));
                    let groupIds = [];
                    if (groupsResponse?.status && groupsResponse?.data) {
                        const findGroupIdsByName = (groups, targetNames) => {
                            let ids = [];
                            const traverse = (list) => {
                                if (!list) return;
                                for (const group of list) {
                                    if (targetNames.some(name => group.name?.toLowerCase().trim() === name.toLowerCase().trim())) {
                                        ids.push(group.id);
                                    }
                                    if (group.sub_primary_group1) {
                                        traverse(group.sub_primary_group1);
                                    }
                                }
                            };
                            traverse(groups);
                            return ids;
                        };
                        groupIds = findGroupIdsByName(groupsResponse.data, ['Sundry Debtors', 'Sundry Creditors']);
                    }

                    // 2. Fetch ledgers for those group IDs
                    const ledgersFormData = new FormData();
                    ledgersFormData.append('group_ids', groupIds.join(','));
                    ledgersFormData.append('company_id', companyId);

                    const response = await dispatch(contraLedgerListing(ledgersFormData));
                    if (response?.status && response?.data) {
                        const sortedLedgers = [...response.data].sort((a, b) =>
                            (a.ledger_name || '').localeCompare(b.ledger_name || '')
                        );
                        setLedgers(sortedLedgers);
                    }
                } catch (error) {
                    console.error("Error fetching groups/ledgers:", error);
                }
            }
        };
        fetchLedgers();
    }, [dispatch, userData, editData]);

    useEffect(() => {
        const fetchUserDetails = async () => {
            if (editData && editData.id) {
                const companyId = userData?.company_id || localStorage.getItem("company_id");
                const formDataObj = new FormData();
                formDataObj.append('company_id', companyId);
                formDataObj.append('id', editData.id);
                try {
                    const response = await dispatch(companyUserList(formDataObj));
                    if (response?.status && response?.data) {
                        const userDetail = Array.isArray(response.data)
                            ? (response.data.find(u => String(u.id) === String(editData.id)) || response.data[0])
                            : response.data;
                        if (userDetail) {
                            const loadedCutOff = userDetail.cut_off_date || userDetail.cutOffDate;
                            const allowedBackDatedVal = userDetail.allowed_back_dated || userDetail.allowedBackDated || formData.allowedBackDated;
                            setFormData(prev => ({
                                ...prev,
                                ledgerName: userDetail.ledger_id || userDetail.account_no || prev.ledgerName,
                                username: userDetail.username || prev.username,
                                email: userDetail.email || prev.email,
                                designation: userDetail.designation || prev.designation,
                                userStatus: userDetail.user_status || userDetail.status || prev.userStatus,
                                allowedBackDated: userDetail.allowed_back_dated || userDetail.allowedBackDated || prev.allowedBackDated,
                                cutOffDate: (userDetail.allowed_back_dated || userDetail.allowedBackDated || prev.allowedBackDated) === 'No' ? '' : (loadedCutOff || prev.cutOffDate),
                            }));
                            if (allowedBackDatedVal === 'No') {
                                setCutOffDateRaw('');
                            } else if (loadedCutOff) {
                                // Strip weekday name for raw display e.g. "23-Dec-2025 (Tuesday)" → "23-Dec-2025"
                                setCutOffDateRaw(loadedCutOff.replace(/\s*\(.*\)/, '').trim());
                            }
                            const rawPerms = userDetail.permissions || userDetail.user_permissions;
                            if (rawPerms) {
                                try {
                                    const parsedPerms = typeof rawPerms === 'string' ? JSON.parse(rawPerms) : rawPerms;
                                    const mapped = mapRawPermissions(parsedPerms);
                                    setPermissions(mapped);
                                    // Deep clone the mapped permissions to avoid sharing references
                                    setInitialPermissions(JSON.parse(JSON.stringify(mapped)));
                                } catch (e) {
                                    console.error("Failed to parse permissions from details API response:", e);
                                }
                            }
                        }
                    }
                } catch (error) {
                    console.error("Failed to fetch user details:", error);
                }
            }
        };
        fetchUserDetails();
    }, [editData, dispatch, userData]);

    const [initialPermissions, setInitialPermissions] = useState(() => {
        if (editData && editData.permissions) {
            try {
                const parsed = typeof editData.permissions === 'string' ? JSON.parse(editData.permissions) : editData.permissions;
                const mapped = mapRawPermissions(parsed);
                // Deep clone to avoid reference sharing
                return JSON.parse(JSON.stringify(mapped));
            } catch (e) {
                console.error("Failed to parse editData permissions:", e);
            }
        }
        return null;
    });

    // Permission Grid rows
    const [permissions, setPermissions] = useState(() => {
        if (editData && editData.permissions) {
            try {
                const parsed = typeof editData.permissions === 'string' ? JSON.parse(editData.permissions) : editData.permissions;
                return mapRawPermissions(parsed);
            } catch (e) {
                console.error("Failed to parse editData permissions:", e);
            }
        }
        return defaultPermissionsList;
    });

    // Active focused cell coordinates for custom navigation [rowIndex, colName]
    const [focusedCell, setFocusedCell] = useState([null, null]);

    // Focus references
    const refs = {
        ledgerName: useRef(null),
        username: useRef(null),
        password: useRef(null),
        confirmPassword: useRef(null),
        email: useRef(null),
        designation: useRef(null),
        userStatus: useRef(null),
        allowedBackDated: useRef(null),
        cutOffDate: useRef(null),
    };

    // Filtered ledgers — used by DropdownLayout_1 via rawData prop
    // (filtering is handled internally by useDropdownFilter hook)

    // Sync ledgerSearch display text when editData ledger loads
    useEffect(() => {
        if (formData.ledgerName && ledgers.length > 0) {
            const sel = ledgers.find(l => String(l.id) === String(formData.ledgerName));
            if (sel) setLedgerSearch(sel.ledger_name);
        }
    }, [ledgers, formData.ledgerName]);

    // Handle ledger select from dropdown (called by DropdownLayout_1 via handleDropdownClick)
    const selectLedger = useCallback((ledger) => {
        setFormData(prev => ({
            ...prev,
            ledgerName: ledger.id,
            email: ledger.email || prev.email
        }));
        setLedgerSearch(ledger.ledger_name);
        setShowLedgerDropdown(false);
        setTimeout(() => refs.username.current?.focus(), 50);
    }, []);

    // Apply parsed cut-off date — uses getVoucherDate exactly like all voucher forms
    const applyCutOffDate = useCallback((rawValue) => {
        if (!rawValue) return false;
        const dateResult = getVoucherDate(rawValue, company_session, formData.cutOffDate);
        if (dateResult && dateResult.formattedDateString) {
            const fullDate = `${dateResult.formattedDateString} (${dateResult.day_show})`;
            setFormData(prev => ({ ...prev, cutOffDate: fullDate }));
            setCutOffDateRaw(dateResult.formattedDateString);
            return true;
        }
        return false;
    }, [company_session, formData.cutOffDate]);

    // Sequential inputs order for Enter key navigation
    const inputOrder = [
        'ledgerName', 'username', 'password', 'confirmPassword', 'email', 'designation', 'userStatus', 'allowedBackDated', 'cutOffDate'
    ];

    const handleFocusReset = () => {
        setSubmitConfirm('');
        if (editData && !viewOnly) {
            refs.username.current?.focus();
        } else {
            refs.ledgerName.current?.focus();
        }
    };

    const submitConfirmRef = useRef(submitConfirm);
    useEffect(() => {
        submitConfirmRef.current = submitConfirm;
    }, [submitConfirm]);

    useEffect(() => {
        // Block global Escape navigation while this modal is open
        document.body.setAttribute('data-modal-open', 'true');
        // Auto focus the first field on mount
        setTimeout(() => {
            if (editData && !viewOnly) {
                refs.username.current?.focus();
            } else {
                refs.ledgerName.current?.focus();
            }
        }, 100);
        return () => {
            document.body.removeAttribute('data-modal-open');
        };
    }, []);

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === 'Escape') {
                if (viewOnly) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    closeModal_sec && closeModal_sec();
                    return;
                }

                if (submitConfirmRef.current) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    handleFocusReset();
                    return;
                }

                event.preventDefault();
                event.stopImmediatePropagation();
                submitConfirmRef.current = 'Quit';
                setSubmitConfirm('Quit');
                document.activeElement?.blur();
            }
        };
        window.addEventListener('keydown', handleKeyPress, true);
        return () => {
            window.removeEventListener('keydown', handleKeyPress, true);
        };
    }, [viewOnly, closeModal_sec]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => {
            const updated = { ...prev, [name]: value };
            if (name === 'ledgerName') {
                const selectedLedger = ledgers.find(l => String(l.id) === String(value));
                if (selectedLedger) {
                    updated.email = selectedLedger.email || '';
                }
            }
            if (name === 'allowedBackDated' && value === 'No') {
                updated.cutOffDate = '';
                setCutOffDateRaw('');
            }
            return updated;
        });
    };

    const permissionCols = ['create', 'alter', 'view', 'delete', 'print', 'export', 'email', 'whatsapp'];

    useEffect(() => {
        if (focusedCell[0] !== null && focusedCell[1] !== null) {
            const element = document.querySelector(`input[data-row="${focusedCell[0]}"][data-col="${focusedCell[1]}"]`);
            element?.focus();
        }
    }, [focusedCell]);

    const validateField = (name) => {
        if (viewOnly) return true;
        if (name === 'ledgerName') {
            if (!formData.ledgerName) {
                toast.error("Ledger Name is required", { position: toast.POSITION.TOP_CENTER });
                refs.ledgerName.current?.focus();
                return false;
            }
        }
        if (name === 'username') {
            if (!formData.username.trim()) {
                toast.error("Username is required", { position: toast.POSITION.TOP_CENTER });
                refs.username.current?.focus();
                return false;
            }
        }
        if (name === 'password') {
            if (!editData && !formData.password) {
                toast.error("Password is required", { position: toast.POSITION.TOP_CENTER });
                refs.password.current?.focus();
                return false;
            }
        }
        if (name === 'confirmPassword') {
            if (formData.password || !editData) {
                if (!formData.confirmPassword) {
                    toast.error("Confirm Password is required", { position: toast.POSITION.TOP_CENTER });
                    refs.confirmPassword.current?.focus();
                    return false;
                }
                if (formData.password !== formData.confirmPassword) {
                    toast.error("Passwords do not match", { position: toast.POSITION.TOP_CENTER });
                    refs.confirmPassword.current?.focus();
                    return false;
                }
            }
        }
        if (name === 'email') {
            if (!formData.email.trim()) {
                toast.error("Email is required", { position: toast.POSITION.TOP_CENTER });
                refs.email.current?.focus();
                return false;
            }
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(formData.email.trim())) {
                toast.error("Invalid email format (e.g. name@domain.com)", { position: toast.POSITION.TOP_CENTER });
                refs.email.current?.focus();
                return false;
            }
        }
        if (name === 'designation') {
            if (!formData.designation.trim()) {
                toast.error("Designation is required", { position: toast.POSITION.TOP_CENTER });
                refs.designation.current?.focus();
                return false;
            }
        }
        if (name === 'userStatus') {
            if (!formData.userStatus.trim()) {
                toast.error("User Status is required", { position: toast.POSITION.TOP_CENTER });
                refs.userStatus.current?.focus();
                return false;
            }
        }
        if (name === 'allowedBackDated') {
            if (!formData.allowedBackDated.trim()) {
                toast.error("Allowed for Back Dated Vouchers is required", { position: toast.POSITION.TOP_CENTER });
                refs.allowedBackDated.current?.focus();
                return false;
            }
        }
        if (name === 'cutOffDate') {
            if (formData.allowedBackDated === 'No') return true;
            if (!formData.cutOffDate) {
                toast.error("Cut-Off Date is required", { position: toast.POSITION.TOP_CENTER });
                refs.cutOffDate.current?.focus();
                return false;
            }
        }
        return true;
    };

    const handleFormKeyDown = (e) => {
        if (e.key === 'Tab' && e.shiftKey) {
            // Shift + Tab: navigate backward without validation
            e.preventDefault();
            const currentIndex = inputOrder.indexOf(e.target.name);
            if (currentIndex > 0) {
                let prevFieldName = inputOrder[currentIndex - 1];
                if (prevFieldName === 'cutOffDate' && formData.allowedBackDated === 'No') {
                    prevFieldName = 'allowedBackDated';
                }
                refs[prevFieldName].current?.focus();
            }
            return;
        }

        if ((e.key === 'Enter' || e.key === 'Tab') && e.target.tagName !== 'TEXTAREA') {
            // If any dropdown is open, let DropdownLayout_1 handle Enter/Tab
            if (showLedgerDropdown && e.target.name === 'ledgerName') return;
            if (showDesignationDropdown && e.target.name === 'designation') return;
            if (showUserStatusDropdown && e.target.name === 'userStatus') return;
            if (showAllowedBackDatedDropdown && e.target.name === 'allowedBackDated') return;

            // Validate current field before allowing to move forward
            if (!validateField(e.target.name)) {
                e.preventDefault();
                return;
            }

            e.preventDefault();
            const currentIndex = inputOrder.indexOf(e.target.name);
            if (currentIndex !== -1) {
                if (e.target.name === 'allowedBackDated' && formData.allowedBackDated === 'No') {
                    setFocusedCell([0, 'create']);
                    return;
                }
                if (currentIndex < inputOrder.length - 1) {
                    const nextFieldName = inputOrder[currentIndex + 1];
                    if (nextFieldName === 'cutOffDate' && formData.allowedBackDated === 'No') {
                        setFocusedCell([0, 'create']);
                        return;
                    }
                    refs[nextFieldName].current?.focus();
                } else if (currentIndex === inputOrder.length - 1) {
                    // Focus first type of access in grid when done with header
                    setFocusedCell([0, 'create']);
                }
            }
        } else if (e.key === 'Escape') {
            e.preventDefault();
            if (viewOnly) {
                closeModal_sec && closeModal_sec();
            } else {
                setSubmitConfirm('Quit');
            }
        }
    };

    const handleCellChange = (rowIndex, field, value) => {
        setPermissions(prev => {
            const updated = [...prev];
            // Shallow clone the row object to prevent in-place mutation of sharing objects
            updated[rowIndex] = { ...updated[rowIndex], [field]: value };
            return updated;
        });
    };

    const handleCellKeyDown = (e, rowIndex, field) => {
        const colIndex = permissionCols.indexOf(field);

        const getNextValidCell = (rIdx, cIdx, direction) => {
            let currRow = rIdx;
            let currCol = cIdx;
            while (true) {
                if (direction === 'down') currRow++;
                else if (direction === 'up') currRow--;
                else if (direction === 'right') currCol++;
                else if (direction === 'left') currCol--;
                else if (direction === 'next') {
                    currCol++;
                    if (currCol >= permissionCols.length) {
                        currCol = 0;
                        currRow++;
                    }
                }
                
                if (currRow < 0 || currRow >= permissions.length) return null;
                if (currCol < 0 || currCol >= permissionCols.length) return null;

                const isRestricted = permissions[currRow].category === 'REPORTS' && 
                    ['create', 'alter', 'delete'].includes(permissionCols[currCol]);
                
                if (!isRestricted) return [currRow, permissionCols[currCol]];
            }
        };

        if (e.key === 'ArrowUp') {
            e.preventDefault();
            const next = getNextValidCell(rowIndex, colIndex, 'up');
            if (next) setFocusedCell(next);
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            const next = getNextValidCell(rowIndex, colIndex, 'down');
            if (next) setFocusedCell(next);
        } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            const next = getNextValidCell(rowIndex, colIndex, 'left');
            if (next) setFocusedCell(next);
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            const next = getNextValidCell(rowIndex, colIndex, 'right');
            if (next) setFocusedCell(next);
        } else if (e.key === 'Tab' || e.key === 'Enter') {
            e.preventDefault();
            const next = getNextValidCell(rowIndex, colIndex, 'next');
            if (next) {
                setFocusedCell(next);
            } else {
                setSubmitConfirm('Accept');
            }
        } else if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            if (viewOnly) {
                closeModal_sec && closeModal_sec();
            } else {
                setSubmitConfirm('Quit');
            }
        }
    };

    const validateForm = () => {
        if (viewOnly) return false;
        for (const field of inputOrder) {
            if (field === 'cutOffDate' && formData.allowedBackDated === 'No') {
                continue;
            }
            if (!validateField(field)) {
                return false;
            }
        }
        return true;
    };

    const prepareSubmitData = () => {
        const companyId = userData?.company_id || localStorage.getItem("company_id");
        const selectedLedger = ledgers.find(l => String(l.id) === String(formData.ledgerName));
        const submitData = {
            company_id: companyId,
            ledger_id: formData.ledgerName,
            ledger_name: selectedLedger ? selectedLedger.ledger_name : '',
            username: formData.username,
            email: formData.email,
            designation: formData.designation,
            user_status: formData.userStatus,
            allowed_back_dated: formData.allowedBackDated,
            cut_off_date: formData.allowedBackDated === 'No' ? '' : formData.cutOffDate
        };

        submitData.permissions = permissions;

        if (formData.password) {
            submitData.password = formData.password;
        }
        if (editData && editData.id) {
            submitData.id = editData.id;
        }
        return prepareFormData(submitData);
    };

    const handleSuccess = (response) => {
        if (onSuccess) {
            const selectedLedger = ledgers.find(l => String(l.id) === String(formData.ledgerName));
            onSuccess({
                id: response?.data?.id || editData?.id,
                name: selectedLedger ? selectedLedger.ledger_name : (response?.data?.name || ''),
                account_no: selectedLedger ? selectedLedger.id : (response?.data?.account_no || formData.ledgerName),
                username: response?.data?.username || formData.username,
                designation: response?.data?.designation || formData.designation,
                email: response?.data?.email || formData.email,
                status: response?.data?.status || formData.userStatus
            });
        }
        closeModal_sec && closeModal_sec();
    };


    const { handleSubmit, loading } = useFormHandler({
        validateForm,
        prepareFormData: prepareSubmitData,
        submitForm: (data) => dispatch(editData ? companyUserUpdate(data) : companyUserCreate(data)),
        isAlter: false,
        shortcuts: [
            {
                key: 'a',
                ctrlKey: true,
                action: () => handleSubmit(new Event('submit')),
            },
        ],
        resetForm: () => {
            setFormData({
                ledgerName: '',
                username: '',
                password: '',
                confirmPassword: '',
                email: '',
                designation: 'Owner',
                userStatus: 'Active',
                allowedBackDated: 'Yes',
                cutOffDate: '23-Dec-2025 (Tuesday)',
            });
            setLedgerSearch('');
            setCutOffDateRaw('23-Dec-2025');
        },
        first_ref: refs.ledgerName,
        closeModal: closeModal_sec,
        onSuccess: handleSuccess,
        setSubmitConfirm,
        submitConfirm,
        customFocusReset: handleFocusReset
    });

    // Dropdown choices
    const designations = ['Owner', 'Manager', 'Accountant', 'Data Entry'];
    const statuses = ['Active', 'Inactive'];
    const yesNoOptions = ['Yes', 'No'];
    return (
        <Form
            handleSubmit={handleSubmit}
            handleKeyDown={handleFormKeyDown}
            submitConfirm={submitConfirm}
            handleFocusReset={handleFocusReset}
            title={viewOnly ? 'User View' : editData ? 'User Alteration' : 'User Creation'}
            loading={loading}
            col='col-12'
            Footer={MasterCreationFooter}
            closeModal_sec={closeModal_sec}
            isView={viewOnly}
            isAlter={!!editData && !viewOnly}
        >
            <div className="container-fluid p-2" style={{ background: '#f8f9fa', fontSize: '12px', display: 'flex', flexDirection: 'column', maxHeight: '80vh' }}>
                {/* Header Information Section */}
                <div className="row g-2 mb-3 bg-white p-3 border rounded shadow-sm">
                    {/* Left Column of Header */}
                    <div className="col-md-6 border-end pe-3">
                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">Ledger Name (Ac No.)</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7" style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="ledgerName"
                                    value={ledgerSearch}
                                    ref={refs.ledgerName}
                                    style={{ fontSize: '12px', background: (viewOnly || !!editData) ? '' : '#eef2f7' }}
                                    disabled={viewOnly || !!editData}
                                    autoComplete="off"
                                    placeholder="Search ledger..."
                                    onChange={e => {
                                        setLedgerSearch(e.target.value);
                                        setShowLedgerDropdown(true);
                                        setFormData(prev => ({ ...prev, ledgerName: '' }));
                                    }}
                                    onFocus={e => {
                                        e.target.select();
                                        if (!viewOnly && !editData) setShowLedgerDropdown(true);
                                    }}
                                    onBlur={() => setTimeout(() => setShowLedgerDropdown(false), 200)}
                                    onKeyDown={e => {
                                        if (e.key === 'Escape') setShowLedgerDropdown(false);
                                    }}
                                />
                                {(!viewOnly && !editData) && (
                                    <DropdownLayout_1
                                        ref={refs.ledgerName}
                                        title="List of Ledger Accounts"
                                        state={showLedgerDropdown}
                                        input_value={ledgerSearch}
                                        input_key="ledger_name"
                                        input_id="id"
                                        rawData={ledgers}
                                        data={formData}
                                        setData={() => { }}
                                        handleDropdownClick={(key, value) => {
                                            const found = ledgers.find(l => l.ledger_name === value);
                                            if (found) selectLedger(found);
                                        }}
                                        inputRefs={refs}
                                        bypassFilter={ledgerSearch === (ledgers.find(l => String(l.id) === String(formData.ledgerName))?.ledger_name || '')}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">Username</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="text"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="username"
                                    value={formData.username}
                                    onChange={handleChange}
                                    onFocus={e => e.target.select()}
                                    ref={refs.username}
                                    style={{ fontSize: '12px' }}
                                    disabled={viewOnly}
                                    autoComplete="new-password"
                                    readOnly={false}
                                />
                            </div>
                        </div>

                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">Password</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                {/* Hidden dummy fields trick browser into not autofilling the real ones */}
                                <input type="text" name="fakeusernameremembered" style={{ display: 'none' }} readOnly />
                                <input type="password" name="fakepasswordremembered" style={{ display: 'none' }} readOnly />
                                <input
                                    type="password"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    onFocus={e => e.target.select()}
                                    ref={refs.password}
                                    style={{ fontSize: '12px' }}
                                    placeholder={editData ? "Leave blank to keep unchanged" : ""}
                                    disabled={viewOnly}
                                    autoComplete="new-password"
                                />
                            </div>
                        </div>

                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">Confirm Password</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="password"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    onFocus={e => e.target.select()}
                                    ref={refs.confirmPassword}
                                    style={{ fontSize: '12px' }}
                                    disabled={viewOnly}
                                    autoComplete="new-password"
                                />
                            </div>
                        </div>

                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">E-mail</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="email"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    onFocus={e => e.target.select()}
                                    ref={refs.email}
                                    style={{ fontSize: '12px' }}
                                    disabled={viewOnly}
                                    autoComplete="new-password"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Right Column of Header - User Settings */}
                    <div className="col-md-6 ps-3 text-start">
                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">Designation</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7" style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="designation"
                                    value={formData.designation}
                                    ref={refs.designation}
                                    style={{ fontSize: '12px', background: viewOnly ? '' : '#eef2f7' }}
                                    disabled={viewOnly}
                                    autoComplete="off"
                                    placeholder="Search Designation..."
                                    onChange={e => {
                                        const val = e.target.value;
                                        setFormData(prev => ({ ...prev, designation: val }));
                                        setShowDesignationDropdown(true);
                                    }}
                                    onFocus={e => {
                                        e.target.select();
                                        if (!viewOnly) setShowDesignationDropdown(true);
                                    }}
                                    onBlur={() => {
                                        setTimeout(() => {
                                            setShowDesignationDropdown(false);
                                            setFormData(prev => {
                                                const match = designations.find(d => d.toLowerCase() === prev.designation.toLowerCase());
                                                if (match) {
                                                    return { ...prev, designation: match };
                                                } else {
                                                    const prevVal = editData ? editData.designation : 'Owner';
                                                    const oldMatch = designations.find(d => d.toLowerCase() === prevVal.toLowerCase());
                                                    return { ...prev, designation: oldMatch || designations[0] };
                                                }
                                            });
                                        }, 200);
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === 'Escape') setShowDesignationDropdown(false);
                                    }}
                                />
                                {!viewOnly && (
                                    <DropdownLayout_1
                                        ref={refs.designation}
                                        title="List of Designations"
                                        state={showDesignationDropdown}
                                        input_value={formData.designation}
                                        input_key="designation"
                                        rawData={designations.map(d => ({ name: d }))}
                                        data={formData}
                                        setData={() => { }}
                                        handleDropdownClick={(key, value) => {
                                            setFormData(prev => ({ ...prev, designation: value }));
                                            setShowDesignationDropdown(false);
                                            setTimeout(() => refs.userStatus.current?.focus(), 50);
                                        }}
                                        inputRefs={refs}
                                        bypassFilter={designations.includes(formData.designation)}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="row align-items-center mb-2">
                            <div className={`col-4 fw-bold text-start ${formData.userStatus === 'Inactive' ? 'text-danger' : 'text-success'}`}>User Status</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7" style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    className={`form-control form-control-sm fw-bold ${formData.userStatus === 'Inactive' ? 'text-danger border-danger' : 'text-success border-success'}`}
                                    name="userStatus"
                                    value={formData.userStatus}
                                    ref={refs.userStatus}
                                    style={{ fontSize: '12px', background: formData.userStatus === 'Inactive' ? '#fdf2f2' : '#eafaf1' }}
                                    disabled={viewOnly}
                                    autoComplete="off"
                                    placeholder="Search Status..."
                                    onChange={e => {
                                        const val = e.target.value;
                                        setFormData(prev => ({ ...prev, userStatus: val }));
                                        setShowUserStatusDropdown(true);
                                    }}
                                    onFocus={e => {
                                        e.target.select();
                                        if (!viewOnly) setShowUserStatusDropdown(true);
                                    }}
                                    onBlur={() => {
                                        setTimeout(() => {
                                            setShowUserStatusDropdown(false);
                                            setFormData(prev => {
                                                const match = statuses.find(s => s.toLowerCase() === prev.userStatus.toLowerCase());
                                                if (match) {
                                                    return { ...prev, userStatus: match };
                                                } else {
                                                    const prevVal = editData ? (editData.status || 'Active') : 'Active';
                                                    const oldMatch = statuses.find(s => s.toLowerCase() === prevVal.toLowerCase());
                                                    return { ...prev, userStatus: oldMatch || statuses[0] };
                                                }
                                            });
                                        }, 200);
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === 'Escape') setShowUserStatusDropdown(false);
                                    }}
                                />
                                {!viewOnly && (
                                    <DropdownLayout_1
                                        ref={refs.userStatus}
                                        title="List of Statuses"
                                        state={showUserStatusDropdown}
                                        input_value={formData.userStatus}
                                        input_key="userStatus"
                                        rawData={statuses.map(s => ({ name: s }))}
                                        data={formData}
                                        setData={() => { }}
                                        handleDropdownClick={(key, value) => {
                                            setFormData(prev => ({ ...prev, userStatus: value }));
                                            setShowUserStatusDropdown(false);
                                            setTimeout(() => refs.allowedBackDated.current?.focus(), 50);
                                        }}
                                        inputRefs={refs}
                                        bypassFilter={statuses.includes(formData.userStatus)}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="row align-items-center mb-2">
                            <div className="col-4 fw-bold text-start">Allowed for Back Dated Vouchers</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7" style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="allowedBackDated"
                                    value={formData.allowedBackDated}
                                    ref={refs.allowedBackDated}
                                    style={{ fontSize: '12px', background: viewOnly ? '' : '#eef2f7' }}
                                    disabled={viewOnly}
                                    autoComplete="off"
                                    placeholder="Search Allowed..."
                                    onChange={e => {
                                        const val = e.target.value;
                                        setFormData(prev => {
                                            const updated = { ...prev, allowedBackDated: val };
                                            if (val.toLowerCase() === 'no') {
                                                updated.cutOffDate = '';
                                                setCutOffDateRaw('');
                                            }
                                            return updated;
                                        });
                                        setShowAllowedBackDatedDropdown(true);
                                    }}
                                    onFocus={e => {
                                        e.target.select();
                                        if (!viewOnly) setShowAllowedBackDatedDropdown(true);
                                    }}
                                    onBlur={() => {
                                        setTimeout(() => {
                                            setShowAllowedBackDatedDropdown(false);
                                            setFormData(prev => {
                                                const match = yesNoOptions.find(y => y.toLowerCase() === prev.allowedBackDated.toLowerCase());
                                                if (match) {
                                                    if (match === 'No') {
                                                        setCutOffDateRaw('');
                                                        return { ...prev, allowedBackDated: match, cutOffDate: '' };
                                                    }
                                                    return { ...prev, allowedBackDated: match };
                                                } else {
                                                    const prevVal = editData ? (editData.allowedBackDated || 'Yes') : 'Yes';
                                                    const oldMatch = yesNoOptions.find(y => y.toLowerCase() === prevVal.toLowerCase());
                                                    if (oldMatch === 'No') {
                                                        setCutOffDateRaw('');
                                                        return { ...prev, allowedBackDated: oldMatch || yesNoOptions[0], cutOffDate: '' };
                                                    }
                                                    return { ...prev, allowedBackDated: oldMatch || yesNoOptions[0] };
                                                }
                                            });
                                        }, 200);
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === 'Escape') setShowAllowedBackDatedDropdown(false);
                                    }}
                                />
                                {!viewOnly && (
                                    <DropdownLayout_1
                                        ref={refs.allowedBackDated}
                                        title="List of Options"
                                        state={showAllowedBackDatedDropdown}
                                        input_value={formData.allowedBackDated}
                                        input_key="allowedBackDated"
                                        rawData={yesNoOptions.map(y => ({ name: y }))}
                                        data={formData}
                                        setData={() => { }}
                                        handleDropdownClick={(key, value) => {
                                            setFormData(prev => {
                                                const updated = { ...prev, allowedBackDated: value };
                                                if (value === 'No') {
                                                    updated.cutOffDate = '';
                                                    setCutOffDateRaw('');
                                                }
                                                return updated;
                                            });
                                            setShowAllowedBackDatedDropdown(false);
                                            if (value === 'No') {
                                                setTimeout(() => setFocusedCell([0, 'create']), 50);
                                            } else {
                                                setTimeout(() => refs.cutOffDate.current?.focus(), 50);
                                            }
                                        }}
                                        inputRefs={refs}
                                        bypassFilter={yesNoOptions.includes(formData.allowedBackDated)}
                                    />
                                )}
                            </div>
                        </div>

                        <div className="row align-items-center">
                            <div className="col-4 fw-bold text-start">Cut-Off Date for Back Dated Vouchers</div>
                            <div className="col-1 text-center">:</div>
                            <div className="col-7">
                                <input
                                    type="text"
                                    className="form-control form-control-sm fw-bold border-secondary"
                                    name="cutOffDate"
                                    value={cutOffDateRaw}
                                    ref={refs.cutOffDate}
                                    style={{ fontSize: '12px', backgroundColor: (viewOnly || formData.allowedBackDated === 'No') ? '#e9ecef' : '' }}
                                    disabled={viewOnly || formData.allowedBackDated === 'No'}
                                    autoComplete="off"
                                    placeholder="dd-mm-yy or dd-mmm-yyyy"
                                    onChange={e => setCutOffDateRaw(e.target.value)}
                                    onBlur={() => {
                                        if (cutOffDateRaw) applyCutOffDate(cutOffDateRaw);
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === 'Tab') {
                                            if (!cutOffDateRaw) {
                                                e.preventDefault();
                                                toast.error('Cut-Off Date is required', { position: toast.POSITION.TOP_CENTER });
                                                refs.cutOffDate.current?.focus();
                                                return;
                                            }
                                            const ok = applyCutOffDate(cutOffDateRaw);
                                            if (!ok) {
                                                e.preventDefault();
                                                toast.error('Invalid date. Try: 23-12-25 or 23-Dec-2025', { position: toast.POSITION.TOP_CENTER });
                                                refs.cutOffDate.current?.select();
                                            } else {
                                                e.preventDefault();
                                                setFocusedCell([0, 'create']);
                                            }
                                        }
                                    }}
                                    onFocus={e => e.target.select()}
                                />
                                {formData.cutOffDate && (
                                    <small style={{ color: '#0d6efd', fontSize: '10px', marginTop: '2px', display: 'block' }}>
                                        {formData.cutOffDate}
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Permissions Grid Section */}
                <div className="bg-white mb-2" style={{ overflowY: 'auto', flex: 1, border: '1px solid #cccccc' }}>
                    <table className="table table-bordered table-sm m-0 user-permission-table" style={{ fontSize: '11px' }}>
                        <thead className="table-secondary fw-bold" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                            <tr>
                                <th rowSpan="2" style={{ width: '25%' }} className="text-start ps-3 align-middle">Facilities / Features Name</th>
                                <th rowSpan="2" style={{ width: '20%' }} className="text-start align-middle">Facilities / Features Type</th>
                                <th colSpan="8" className="text-center py-1">Permissions</th>
                            </tr>
                            <tr>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>Create</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>Alter</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>View</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>Delete</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>Print</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>Export</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>Email</th>
                                <th className="text-center py-1" style={{ width: '6.8%' }}>WhatsApp</th>
                            </tr>
                        </thead>
                        <tbody>
                            {permissions.map((item, idx) => {
                                // Group divider rendering
                                const showCategoryHeader = idx === 0 || permissions[idx - 1].category !== item.category;

                                return (
                                    <React.Fragment key={item.id}>
                                        {showCategoryHeader && (
                                            <tr className="table-light">
                                                <td colSpan="10" className="text-start fw-bold ps-2 py-1 text-secondary" style={{ background: '#f0f0f0', fontSize: '11px', letterSpacing: '0.5px' }}>
                                                    {item.category}
                                                </td>
                                            </tr>
                                        )}
                                        <tr className="align-middle">
                                            <td className="text-start ps-3 fw-bold text-dark">{item.name}</td>
                                            <td className="text-start text-muted">{item.type}</td>
                                            {permissionCols.map(col => {
                                                const isFocused = focusedCell[0] === idx && focusedCell[1] === col;
                                                const isRestricted = item.category === 'REPORTS' && ['create', 'alter', 'delete'].includes(col);
                                                return (
                                                    <td
                                                        key={col}
                                                        className="text-center p-0"
                                                        style={{
                                                            background: isFocused ? '#eef2f7' : 'transparent',
                                                            outline: isFocused ? '1px dashed #0d6efd' : 'none',
                                                            outlineOffset: '-1px'
                                                        }}
                                                    >
                                                        {!isRestricted && (
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={!!item[col]}
                                                                data-row={idx}
                                                                data-col={col}
                                                                onChange={(e) => handleCellChange(idx, col, e.target.checked)}
                                                                onKeyDown={(e) => handleCellKeyDown(e, idx, col)}
                                                                onFocus={() => setFocusedCell([idx, col])}
                                                                style={{ cursor: 'pointer', margin: '4px 0' }}
                                                                disabled={viewOnly}
                                                            />
                                                        )}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </Form>
    );
}

export default React.memo(UserAndPasswordCreate);
